(function () {
  if (window.__deliveryTimelineLoaded) return;
  window.__deliveryTimelineLoaded = true;

  var ICON_CART = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="dt-stroke"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="dt-stroke"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="dt-stroke"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';

  var MONTHS_FR = ['Jan','Fev','Mar','Avr','Mai','Juin','Juil','Aout','Sept','Oct','Nov','Dec'];

  var TOOLTIPS = {
    order: 'Votre commande est confirmée immédiatement après l’achat',
    ship: 'Votre colis est préparé puis remis au transporteur',
    delivered: 'Date estimée de réception à votre adresse'
  };

  var MONTHS_FULL = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
  function fmt(d) {
    return d.getDate() + ' ' + MONTHS_FULL[d.getMonth()];
  }
  function range(a, b) {
    if (a.getMonth() === b.getMonth()) return a.getDate() + '–' + b.getDate() + ' ' + MONTHS_FULL[b.getMonth()];
    return fmt(a) + ' – ' + fmt(b);
  }

  function esc(s) {
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function buildTimelineHTML() {
    var today = new Date();
    var ship = new Date(today.getTime()); ship.setDate(ship.getDate() + 1);
    var delivered = new Date(ship.getTime()); delivered.setDate(delivered.getDate() + 6);
var delivered2 = new Date(ship.getTime()); delivered2.setDate(delivered2.getDate() + 8);

    return (
      '<div class="delivery-timeline">' +
        '<div class="delivery-timeline__step">' +
          '<div class="delivery-timeline__icon" tabindex="0" data-tooltip="' + esc(TOOLTIPS.order) + '">' + ICON_CART + '</div>' +
          '<p class="delivery-timeline__date">' + fmt(today) + '</p>' +
          '<p class="delivery-timeline__label">Commandée</p>' +
        '</div>' +
        '<div class="delivery-timeline__connector"></div>' +
        '<div class="delivery-timeline__step">' +
          '<div class="delivery-timeline__icon" tabindex="0" data-tooltip="' + esc(TOOLTIPS.ship) + '">' + ICON_TRUCK + '</div>' +
          '<p class="delivery-timeline__date">' + fmt(ship) + '</p>' +
          '<p class="delivery-timeline__label">Expédiée</p>' +
        '</div>' +
        '<div class="delivery-timeline__connector"></div>' +
        '<div class="delivery-timeline__step">' +
          '<div class="delivery-timeline__icon" tabindex="0" data-tooltip="' + esc(TOOLTIPS.delivered) + '">' + ICON_CHECK + '</div>' +
          '<p class="delivery-timeline__date">' + fmt(delivered) + '</p>' +
          '<p class="delivery-timeline__label">Livrée</p>' +
        '</div>' +
      '</div>'
    );
  }

  function findAnchor() {
    return (
      document.querySelector('product-form .product-form__buttons') ||
      document.querySelector('.product-form__buttons') ||
      document.querySelector('#productMainSubmit') ||
      document.querySelector('button[name="add"]')
    );
  }

  function insertTimeline() {
    if (document.querySelector('.delivery-timeline')) return;
    if (!/\/products\//.test(window.location.pathname)) return;

    var anchor = findAnchor();
    if (!anchor) return;

    var container =
      (anchor.closest && (anchor.closest('product-form') || anchor.closest('.product-form'))) ||
      anchor.parentElement;
    if (!container || !container.parentNode) return;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildTimelineHTML();
    container.parentNode.insertBefore(wrapper.firstElementChild, container.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertTimeline);
  } else {
    insertTimeline();
  }
  document.addEventListener('shopify:section:load', insertTimeline);
  // 22/10 : sur mobile, la bulle s'affiche au toucher puis disparait seule
  document.addEventListener('click', function (e) {
    var ic = e.target.closest && e.target.closest('.delivery-timeline__icon');
    document.querySelectorAll('.delivery-timeline__icon.dt-show').forEach(function (x) { if (x !== ic) x.classList.remove('dt-show'); });
    if (!ic) return;
    ic.classList.add('dt-show');
    if (ic.blur) ic.blur();
    clearTimeout(ic._dtT);
    ic._dtT = setTimeout(function () { ic.classList.remove('dt-show'); }, 2500);
  });

})();
